import { JSX } from 'react';
import { Theme } from '@mui/material/styles';
import { withStyles } from 'tss-react/mui';
import MuiFormGroup from '@mui/material/FormGroup';
import MuiFormLabel from '@mui/material/FormLabel';
import classNames from 'classnames';
import { CommonPropsAndTypes } from '../_Types/StandardComponentProps';

interface IProps {
  children: JSX.Element;
  row?: boolean;
  line?: boolean;
  label?: string;
  size?: CommonPropsAndTypes.StandardSizesType;
  classes?: any;
}

const styles = (theme: Theme) => ({
  box: {
    position: 'relative',
    paddingTop: theme.spacing(1),
    marginTop: theme.spacing(0.5),
  },
  groupLabel: {
    display: 'flex',
    position: 'absolute',
    top: theme.spacing(-1),
    left: theme.spacing(0),
    width: `calc(100% + ${theme.spacing(1)})`,
    color: theme.customProperties.Fade.DarkOnLight.lowEmphasis,
    '& span': {
      display: 'inline-flex',
      padding: theme.spacing(0, 1),
      flexGrow: 0,
    },
    '&:before': {
      display: 'inline-flex',
      content: '""',
      width: theme.spacing(2),
      flexGrow: 0,
      position: 'relative',
      top: theme.spacing(1), // FIXME: kolla noga effekten av att det tidigare var '0.325rem' (5.2px),
      borderTop: theme.customProperties.FormLabel.border,
    },
    '&:after': {
      display: 'inline-flex',
      content: '""',
      width: theme.spacing(2),
      flexGrow: 2,
      position: 'relative',
      top: theme.spacing(1), // FIXME: kolla noga effekten av att det tidigare var '0.325rem' (5.2px),
      borderTop: theme.customProperties.FormLabel.border,
    },
  },
  mediumLabel: {
    fontSize: theme.typography.pxToRem(14),
  },
  smallLabel: {
    fontSize: theme.typography.pxToRem(12),
  },
});

/**
 * En titelrad med styling för att tydligt rubricera underliggande värde.
 */
export const EDFormGroup = (props: IProps) => {
  const { classes, line, children, label, size, ...other } = props;
  return (
    <MuiFormGroup {...other} className={classNames({ [classes.box]: line })}>
      {label && (
        <MuiFormLabel
          className={classNames({
            [classes.groupLabel]: line,
            [classes.mediumLabel]: size === 'medium' || size === 'large',
            [classes.smallLabel]: size === 'small',
          })}
        >
          <span>{label}</span>
        </MuiFormLabel>
      )}

      {children}
    </MuiFormGroup>
  );
};

export default withStyles(EDFormGroup, styles);
